import { CompanySize, DurationType } from '../../../__generated__/graphql';

export interface DurationInput {
  type: DurationType;
  value: number;
}

export const COMPANY_SIZE_OPTIONS = [
  { value: CompanySize.Small, label: '1-10 employees' },
  { value: CompanySize.Medium, label: '11-50 employees' },
  { value: CompanySize.Large, label: '51-200 employees' },
  { value: CompanySize.ExtraLarge, label: '201-500 employees' },
  { value: CompanySize.Enterprise, label: '500+ employees' },
];

export const DURATION_TYPE_OPTIONS = [
  { value: DurationType.Days, label: 'Days' },
  { value: DurationType.Weeks, label: 'Weeks' },
  { value: DurationType.Months, label: 'Months' },
  { value: DurationType.Years, label: 'Years' },
];

export const EMPLOYMENT_TYPE_OPTIONS = [
  { value: 'FULL_TIME', label: 'Full-time' },
  { value: 'PART_TIME', label: 'Part-time' },
  { value: 'CONTRACT', label: 'Contract' },
  { value: 'TEMPORARY', label: 'Temporary' },
  { value: 'INTERNSHIP', label: 'Internship' },
];